var map = {
	"./logo-batik-air.png": "5c51",
	"./logo-client.png": "4278",
	"./logo-console.png": "4e8d",
	"./logo-genesis-2x.png": "b821",
	"./logo-genesis-3x.png": "d9bc",
	"./logo-genesis.png": "ae8f",
	"./logo-internal.png": "6001",
	"./logo-lion-air.png": "bc03",
	"./logo-lion-parcel-3x.png": "705c6",
	"./logo-lion-parcel-black.png": "5143",
	"./logo-lion-parcel.png": "b5e3",
	"./logo-pos.png": "6377",
	"./logo-priority-print.png": "8b87",
	"./logo-sub-console.png": "b7bb",
	"./logo-super-air-jet-short.png": "47b6",
	"./logo-super-jet-air.png": "8949",
	"./logo-vendor.png": "23c3",
	"./logo-wings-air.png": "3659"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cd0";